<template>
  <div class="project-resource2">
    <base-table
      ref="table"
      row-key="id"
      :init-search="false"
      :show-pagination="false"
      :columns="columns"
      stripe
      border
    ></base-table>
    <base-dialog
      :title="dialogTitle"
      v-model="showDialog"
      @ok="saveData"
      :ok-loading="okLoading"
    >
      <base-form
        :init-value="false"
        v-model="formData"
        ref="form"
        :rules="rules"
        :form-items="formItems"
      ></base-form>
    </base-dialog>
    <input ref="copytext" type="text" class="copy-text-control" />
    <form v-show="false" ref="importForm">
      <input
        type="file"
        ref="importFile"
        accept=".xlsx"
        @change="onImportResourceActiveEnvsFileChange"
      />
    </form>
  </div>
</template>
<script>
import {
  deepTreeData,
  foreachTreeItem,
  deepGetResTreeName,
  getMenuIcons,
  isInactive
} from '../plugins/utils'
import { exportXlsxFile, readXlsxFileToJson } from '../plugins/exceljs'
const baseResTypeOptions = [
  { label: '功能资源', value: 'normal' },
  { label: '菜单资源', value: 'menu' }
]
export default {
  name: 'project-resource2',
  props: {
    active: Boolean, //组件是否激活
    project: Object
  },

  data() {
    var resourceCascaderBind = { options: [], nid: '' }
    var relResourceCascaderBind = {
      checkStrictly: true,
      options: [],
      topLevel: false,
      multiple: false,
      calcItemDisabled: (disabled, row) => {
        if (row.res_type == 'normal' || row.meun_path) {
          return false
        }
        return true
      }
    }
    // var roleStateListBind = {
    //   projectid: this.project.id,
    //   resid: '',
    //   ref: 'roleStateList'
    // }
    var resTypeBind = { options: [...baseResTypeOptions] }
    console.log('this.$root.environment', this.$root.environment)
    var isProd = this.$root.environment == 'prod'
    return {
      importResourceActiveEnvsLoading: false,
      columns: [
        {
          bind: { label: '资源名称', prop: 'name' },
          default: {
            component: 'cell-render-vnode',
            bind: {
              vnode: (scope, defaultValue) => {
                var name = defaultValue
                var icons = getMenuIcons(scope.row)
                if (scope.row.res_type == 'rel' && scope.row.use_rel_name) {
                  name = (
                    <span class='user-rel-name' title='使用引用资源名称'>
                      {scope.row.rel_name}
                    </span>
                  )
                }
                var inactive = isInactive(scope.row, this.$root.environment)
                return (
                  <span
                    class={inactive ? 'inactive-node' : ''}
                    title={inactive ? '该资源在当前环境已禁用' : ''}
                  >
                    {icons.map((icon) => (
                      <i class={icon} style='margin-right: 2px'></i>
                    ))}
                    {name}
                  </span>
                )
              }
            }
          }
        },
        {
          bind: { label: '资源名称(英语)', prop: 'name_en' },
          default: {
            component: 'cell-render-vnode',
            bind: {
              vnode: (scope, defaultValue) => {
                if (scope.row.res_type == 'rel' && scope.row.use_rel_name) {
                  return (
                    <span class='user-rel-name' title='使用引用资源名称'>
                      {scope.row.rel_name_en}
                    </span>
                  )
                }
                return <span>{defaultValue}</span>
              }
            }
          }
        },
        {
          bind: { label: '资源类型', prop: 'res_type', width: 100 },
          default: {
            component: 'cell-text',
            bind: {
              formatter(scope, value) {
                switch (scope.row.res_type) {
                  case 'menu':
                    return '菜单资源'
                  case 'normal':
                    return '功能资源'
                  case 'rel':
                    if (scope.row.rel_res_type == 'menu') {
                      return '引用菜单资源'
                    } else if (scope.row.rel_res_type == 'normal') {
                      return '引用功能资源'
                    }
                }
                return ''
              }
            }
          }
        },
        {
          bind: { label: '引用项目', prop: 'rel_project_name', width: 150 }
        },
        {
          bind: { label: '菜单路径', prop: 'meun_path' },
          default: {
            component: 'cell-text',
            bind: {
              formatter(scope, value) {
                switch (scope.row.res_type) {
                  case 'menu':
                    return value
                  case 'rel':
                    return scope.row.rel_meun_path
                }
                return ''
              }
            }
          }
        },
        {
          bind: { label: '激活环境', prop: 'active_envs', width: 140 },
          header: isProd
            ? {
                component: 'cell-render-vnode',
                bind: {
                  vnode: (scope) => {
                    return (
                      <div>
                        <span style='margin-right: 2px;'>激活环境</span>
                        <el-button
                          type='text'
                          loading={this.importResourceActiveEnvsLoading}
                          onclick={() => {
                            this.importResourceActiveEnvs()
                          }}
                        >
                          批量导入
                        </el-button>
                      </div>
                    )
                  }
                }
              }
            : undefined,
          default: {
            component: 'cell-render-vnode',
            bind: {
              vnode: (scope, defaultValue) => {
                var activeEnvsString = defaultValue
                if (!activeEnvsString) {
                  return null
                }

                const activeEnvs = activeEnvsString.split(',')
                return (
                  <div class='active-env-tag-wrap'>
                    {activeEnvs.map((activeEnv) => {
                      return (
                        <el-tag type='primary' size='mini' effect='dark'>
                          {this.$store.state.activeEnvs[activeEnv] || activeEnv}
                        </el-tag>
                      )
                    })}
                  </div>
                )
              }
            }
          }
        },
        {
          bind: { label: '排序', prop: 'sort_order', width: 60 }
        },
        {
          bind: { label: '操作', prop: 'oper', width: 220 },
          header: {
            component: 'cell-render-vnode',
            bind: {
              vnode: (scope) => {
                return (
                  <div>
                    {isProd ? (
                      <el-button
                        type='primary'
                        onclick={() => {
                          this.beginAdd()
                        }}
                      >
                        新增
                      </el-button>
                    ) : null}
                    <el-button
                      size='mini'
                      onclick={() => {
                        this.exportResource()
                      }}
                    >
                      导出
                    </el-button>
                    <el-button
                      icon='el-icon-refresh'
                      size='mini'
                      onclick={() => {
                        this.refreshProjectResource()
                      }}
                    ></el-button>
                  </div>
                )
              }
            }
          },
          default: {
            component: 'cell-render-vnode',
            bind: {
              vnode: (scope) => {
                return (
                  <div>
                    <el-button
                      type='text'
                      onclick={() => {
                        this.copyId(scope)
                      }}
                    >
                      复制ID
                    </el-button>
                    {isProd ? (
                      <el-button
                        type='text'
                        onclick={() => {
                          this.beginEdit(scope.row)
                        }}
                      >
                        编辑
                      </el-button>
                    ) : null}
                    {isProd && scope.row.res_type != 'rel' ? (
                      <el-button
                        type='text'
                        onclick={() => {
                          this.beginAdd(scope.row)
                        }}
                      >
                        新增下级
                      </el-button>
                    ) : null}
                    {isProd ? (
                      <el-button
                        type='text'
                        onclick={() => {
                          this.del(scope.row)
                        }}
                      >
                        删除
                      </el-button>
                    ) : null}
                  </div>
                )
              }
            }
          }
        }
      ],
      loading: false,
      okLoading: false,
      showDialog: false,
      dialogTitle: '添加资源',
      formData: {},
      currEditData: {}, //当前修改的项
      formItems: [],
      resourceCascaderBind,
      relResourceCascaderBind,
      // roleStateListBind,
      resTypeBind,
      baseFormItems: [
        {
          label: '资源类型',
          prop: 'res_type',
          component: 'form-select',
          bind: resTypeBind,
          on: {
            change: (val) => {
              this.updateFormItem()
            }
          }
        },
        {
          label: '引用项目',
          prop: 'rel_project',
          component: 'form-select-project',
          requireProp(data) {
            if (data.res_type == 'rel') {
              return true
            }
            return false
          },
          bind: {
            type: 'normal'
          },
          on: {
            change: (val) => {
              this.updateFormItem()
            }
          }
        },
        {
          label: '引用资源',
          prop: 'rel_id',
          component: 'resource-cascader',
          bind: relResourceCascaderBind,
          requireProp(data) {
            if (data.res_type == 'rel' && data.rel_project) {
              return true
            }
            return false
          },
          on: {
            selected: (val) => {
              this.updateFormItem()
            }
          }
        },
        {
          label: '使用引用资源名称',
          prop: 'use_rel_name',
          component: 'el-switch',
          requireProp(data) {
            if (data.res_type == 'rel' && data.rel_id) {
              return true
            }
            return false
          },
          on: {
            change: (val) => {
              this.updateFormItem()
            }
          }
        },
        {
          label: '资源名称',
          prop: 'name',
          requireProp(data) {
            if (data.res_type == 'menu' || !data.use_rel_name) {
              return true
            }
            return false
          }
        },
        {
          label: '资源名称(英语)',
          prop: 'name_en',
          requireProp(data) {
            if (data.res_type == 'menu' || !data.use_rel_name) {
              return true
            }
            return false
          }
        },

        {
          label: '菜单路径',
          prop: 'meun_path',
          requireProp(data) {
            if (data.res_type == 'menu') {
              return true
            }
            return false
          }
        },
        {
          label: '资源父级',
          prop: 'pid',
          component: 'resource-cascader',
          bind: resourceCascaderBind
        },
        {
          label: '激活环境',
          prop: 'active_envs',
          component: 'form-select',
          bind: {
            multiple: true,
            join: ',',
            filterable: true,
            allowCreate: true,
            clearable: true,
            options: this.$getOptions('activeEnvs')
          }
        },
        {
          label: '排序',
          prop: 'sort_order',
          component: 'el-input-number',
          bind: {
            'controls-position': 'right',
            precision: 2,
            step: 0.01
          }
        }
        // {
        //   label: '资源权限',
        //   prop: 'roles',
        //   component: 'role-state-list',
        //   bind: roleStateListBind
        // }
      ],
      rules: {
        name: [
          {
            required: true,
            message: '请输入资源名称',
            trigger: ['blur', 'change']
          },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: ['blur', 'change']
          }
        ],
        res_type: [
          {
            required: true,
            message: '请选择资源类型',
            trigger: ['blur', 'change']
          }
        ],
        pid: [
          {
            required: true,
            message: '请选择父级资源',
            trigger: ['blur', 'change']
          }
        ],
        rel_project: [
          {
            required: true,
            message: '请选择引用项目',
            trigger: ['blur', 'change']
          }
        ],
        rel_id: [
          {
            required: true,
            message: '请选择引用资源',
            trigger: ['blur', 'change']
          }
        ]
      },
      allResourceData: [],
      tree: []
    }
  },
  created() {
    this.updateFormItem()
  },
  methods: {
    refreshProjectResource() {
      clearTimeout(window.refreshProjectResourceTimeout)
      window.refreshProjectResourceTimeout = setTimeout(() => {
        this.loading = true
        this.getProjectResource(this.project.id).then(({ tree, total }) => {
          this.loading = false
          this.tree = tree
          this.$refs.table.setTableData({
            rows: tree,
            total
          })
        })
      }, 100)
    },
    getProjectResource(projectid, res_type) {
      console.log('getProjectResource')
      var params = {
        PageIndex: 1,
        PageSize: 9999,
        project: JSON.stringify({
          Field: 'a.project',
          ComparePattern: 'EQ',
          Values: [projectid]
        }),
        SortFields: JSON.stringify([
          {
            Field: 'a.sort_order',
            Order: 1
          }
        ])
      }
      if (res_type) {
        params.res_type = JSON.stringify({
          Field: 'a.res_type',
          ComparePattern: 'EQ',
          Values: [res_type]
        })
      }
      return this.$post('/resource/findRelView', params)
        .then((resp) => {
          if (resp.data.code == 0) {
            this.allResourceData = resp.data.data.Data
            return {
              tree: deepTreeData(resp.data.data.Data, '0'),
              total: resp.data.data.Total || 0
            }
          } else {
            this.$message(resp.data.msg || '获取项目资源失败')
            return {
              tree: [],
              total: 0
            }
          }
        })
        .catch((error) => {
          this.$message('获取项目资源发生异常=>' + error)
          return {
            tree: [],
            total: 0
          }
        })
    },

    calcFormItems() {
      var formItems = []
      for (var item of this.baseFormItems) {
        if (typeof item.requireProp == 'function') {
          if (item.requireProp(this.formData)) {
            formItems.push(item)
          }
        } else {
          formItems.push(item)
        }
      }
      this.formItems = formItems
    },
    calcFormItemRules() {
      if (this.formData.res_type == 'menu') {
        this.$set(this.rules, 'name_en', [
          {
            required: true,
            message: '请输入资源名称(英语)',
            trigger: ['blur', 'change']
          },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 255 个字符',
            trigger: ['blur', 'change']
          }
        ])
        // this.rules.meun_path = [
        //   {
        //     required: true,
        //     message: '请输入菜单路径',
        //     trigger: ['blur', 'change']
        //   },
        //   {
        //     min: 1,
        //     max: 50,
        //     message: '长度在 1 到 100 个字符',
        //     trigger: ['blur', 'change']
        //   }
        // ]
      } else {
        this.$set(this.rules, 'name_en', [])
        if (this.$refs.form && this.$refs.form.$refs) {
          this.$refs.form.$refs.form.clearValidate('name_en')
        }
      }
    },
    updateFormItem() {
      this.calcFormItems()
      this.calcFormItemRules()
    },
    beginAdd(data) {
      this.resourceCascaderBind.nid = ''
      // this.roleStateListBind.resid = ''
      this.showDialog = true
      this.dialogTitle = '添加资源'
      setTimeout(() => {
        this.formData = {
          domain: this.project.domain,
          project: this.project.id,
          name: '',
          name_en: '',
          res_type: this.resTypeBind.options[0].value,
          rel_id: '',
          rel_project: '',
          use_rel_name: false,
          meun_path: '',
          active_envs: '',
          sort_order: 1.0,
          roles: [],
          pid: data && data.id ? data.id : '0'
        }
        // this.$refs.form.$refs.roleStateList.doRefresh() //需要每次触发计算roles字段
        this.updateFormItem()
      }, 100)
    },
    beginEdit(data) {
      this.resourceCascaderBind.nid = data.id
      // this.roleStateListBind.resid = data.id
      this.dialogTitle = '修改资源'
      this.showDialog = true
      setTimeout(() => {
        this.currEditData = data
        this.formData = Object.assign({ roles: [] }, data)
        // this.$refs.form.$refs.roleStateList.doRefresh() //需要每次触发计算roles字段
        this.updateFormItem()
      }, 100)
    },
    del(data) {
      var items = this.getRemoveItems(data)
      if (
        confirm(
          '确定删除"' +
            (data.name || data.rel_name) +
            '"' +
            (items.length > 1 ? '，以及其下的子资源?' : '?')
        )
      ) {
        this.$post('/resource/removes', {
          parameters: JSON.stringify(items)
        }).then((resp) => {
          if (resp.data.code == 0) {
            // this.removeTreeItem(data, true)
            this.refreshProjectResource()
          } else {
            this.$message(resp.data.msg || '删除失败')
          }
        })
      }
    },
    saveData() {
      this.$refs.form.validate((flag, fields) => {
        if (flag) {
          var isAdd = !this.formData.id
          this.okLoading = true
          if (this.formData.res_type == 'rel') {
            if (this.formData.use_rel_name) {
              this.formData.name = null
              this.formData.name_en = null
            }
          } else {
            this.formData.use_rel_name = false
            this.formData.rel_id = null
            this.formData.rel_project = null
          }
          this.$post('/resource/' + (isAdd ? 'addAndRole' : 'updateAndRole'), {
            parameters: JSON.stringify(this.formData)
          })
            .then((resp) => {
              this.okLoading = false
              if (resp.data.code == 0) {
                this.showDialog = false
                // if (isAdd) {
                //   this.addTreeItem(resp.data.data)
                // } else {
                //   this.updateTreeItem(resp.data.data)
                // }
                this.refreshProjectResource()
              } else {
                this.$message(resp.data.msg || '操作失败')
              }
            })
            .catch((err) => {
              console.error('请求发生异常', err)
              this.$message('请求发生异常' + err)
            })
        } else {
          this.$message('请填写完整')
        }
      })
    },
    cloneItem(item) {
      var obj = {}
      for (var key in item) {
        if (key != 'children') {
          obj[key] = item[key]
        }
      }
      return obj
    },
    getRemoveItems(item) {
      var ids = [item.id]
      var ret = [this.cloneItem(item)]
      if (Array.isArray(item.children)) {
        foreachTreeItem(item.children, (row, rows) => {
          if (ids.indexOf(row.pid) > -1) {
            ids.push(row.id)
            ret.push(this.cloneItem(row))
          }
        })
      }
      return ret
    },
    exportResource() {
      if (this.tree.length == 0) {
        this.$message('没有数据可导出')
        return
      }
      var data = []
      foreachTreeItem(this.tree, (row, rows) => {
        //使用foreachTreeItem遍历主要为了跟表格顺序一样
        var result = []
        deepGetResTreeName(this.allResourceData, row.id, result)
        data.push({
          id: row.id,
          resTreeName: result.reverse().join(' / '),
          active_envs: row.active_envs,
          rel_project_name: row.rel_project_name,
          rel_active_envs: row.rel_active_envs
        })
      })
      exportXlsxFile(
        `${this.project.name}_所有资源_${new Date().getTime()}.xlsx`,
        [
          { header: '资源ID', key: 'id' },
          { header: '引用项目', key: 'rel_project_name' },
          { header: '资源名称', key: 'resTreeName' },
          { header: '激活环境', key: 'active_envs' }
          // { header: '激活环境(引用)', key: 'rel_active_envs' }
        ],
        {},
        data
      )
    },
    importResourceActiveEnvs() {
      this.$refs.importFile.click()
    },
    async onImportResourceActiveEnvsFileChange(e) {
      var file = e.target.files[0]
      if (file) {
        console.log('file', file)
        var ext = file.name.split('.').pop()
        if (ext != 'xlsx') {
          this.$message('请上传xlsx文件')
          return
        }
        try {
          var data = await readXlsxFileToJson(file, {
            keyMap: {
              资源ID: 'id',
              激活环境: 'active_envs'
            }
          })
          console.log('readXlsxFileToJson=>data', data)
          if (data.length == 0) {
            this.$message('没有数据可导入')
            return
          }
          if (data.some((item) => !item.id)) {
            this.$message('资源ID不能为空，请检查文件内容')
            return
          }

          if (
            data.some((item) => {
              if (!item.active_envs) {
                return false
              }
              const activeEnvs = item.active_envs.split(',')
              for (const env of activeEnvs) {
                if (!this.$store.state.activeEnvs[env]) {
                  return true
                }
              }
              return false
            })
          ) {
            this.$message(
              `激活环境仅支持以下环境: ${Object.keys(
                this.$store.state.activeEnvs
              ).join(', ')}`
            )
            return
          }
          this.endImportResourceActiveEnvs(data)
        } catch (error) {
          console.error('读取xlsx文件发生异常=>', error)
          this.$message(`读取${file.name}文件失败，请检查文件内容`)
        } finally {
          this.$refs.importForm.reset()
        }
      }
    },
    endImportResourceActiveEnvs(data) {
      console.log('endImportResourceActiveEnvs=>data', data)
      this.importResourceActiveEnvsLoading = true
      this.$postObj('/resource/importResourceActiveEnvs', {
        domain: this.project.domain,
        project: this.project.id,
        resourceActiveEnvs: data.map((item) => {
          return {
            id: item.id,
            active_envs: item.active_envs
          }
        })
      })
        .then((resp) => {
          this.importResourceActiveEnvsLoading = false
          if (resp.data.code == 0) {
            this.$message({
              message: '导入成功',
              type: 'success'
            })
            this.refreshProjectResource()
          } else {
            this.$message(`导入失败:${resp.data.msg}`)
          }
        })
        .catch((err) => {
          this.importResourceActiveEnvsLoading = false
          console.error('导入发生异常=>', err)
          this.$message(`导入发生异常:${err}`)
        })
    },
    copyId(scope) {
      this.$refs.copytext.value = scope.row.id
      this.$refs.copytext.select()
      document.execCommand('copy')
      this.$message({
        duration: 1000,
        message: '已复制到剪切板',
        type: 'success'
      })
    }
  },
  watch: {
    active: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refreshProjectResource()
        }
      }
    },
    loading(newVal) {
      this.$refs.table.loading = newVal
    },
    project: {
      immediate: true,
      handler(newVal) {
        this.refreshProjectResource()
        console.log('project', newVal)
        if (newVal.type == 'integration') {
          this.resTypeBind.options = [
            { label: '引用资源', value: 'rel' },
            ...baseResTypeOptions
          ]
        } else {
          this.resTypeBind.options = [...baseResTypeOptions]
        }
      }
    },
    tree(newVal) {
      this.resourceCascaderBind.options = newVal
    },
    'formData.rel_project': {
      handler(newVal) {
        if (newVal) {
          this.getProjectResource(newVal).then(({ tree, total }) => {
            console.log('tree', tree)
            this.relResourceCascaderBind.options = tree
          })
        }
      }
    }
  }
}
</script>
<style lang="less">
.project-resource2 {
  height: 750px;
  overflow: auto;
  .copy-text-control {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 1px;
    height: 1px;
    margin: 0;
    padding: 0;
    border: none;
    opacity: 0;
  }
  .user-rel-name {
    color: #999;
    font-style: italic;
  }
  .inactive-node {
    color: #f56c6c;
    text-decoration: line-through;
    .user-rel-name {
      color: #f56c6c;
    }
  }
}
</style>
